module.exports = __webpack_public_path__ + "img/xhcc.c767a6af.jpg";